"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.schema = void 0;
var EditorTypes_1 = require("../EditorTypes");
var Table_1 = require("ContentTokens/DataModels/Table");
var EditorWidgetRegistry_1 = require("../WidgetRegistry/EditorWidgetRegistry");
exports.schema = {
    editor: {
        validChildren: [EditorTypes_1.BlockType.Table],
        validFirstChild: [],
    },
    blocks: (_a = {},
        _a[EditorTypes_1.BlockType.Table] = {},
        _a[EditorTypes_1.BlockType.TableCell] = {
            validChildren: [],
            createDefaultChildNode: function () { return (0, EditorWidgetRegistry_1.createParagraphNode)(); },
            isContainerType: true,
        },
        _a[EditorTypes_1.BlockType.TableDummy] = {
            isVoid: true,
        },
        _a[EditorTypes_1.BlockType.TableRow] = {
            validChildren: [EditorTypes_1.BlockType.TableCell],
            createDefaultChildNode: function () { return (0, Table_1.createEmptyTableCellNode)(); },
            isContainerType: true,
        },
        _a),
    inlines: (_b = {},
        _b[EditorTypes_1.InlineType.LineBreak] = {
            isVoid: true,
        },
        _b[EditorTypes_1.InlineType.TokenWidget] = {
            isVoid: true,
        },
        _b[EditorTypes_1.InlineType.Variable] = {
            isVoid: true,
            marks: false,
        },
        _b),
    name: "agreement",
};
